// import React from 'react'
import { accountProfileUrl } from '@npm/sso-auth'
import ReactDOM from 'react-dom/client'

import { MemberLicenses } from '../../pages/member'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  root.render(
    // <React.StrictMode>
    <MemberLicenses ssoUrl={accountProfileUrl} />
    // </React.StrictMode>
  )
}
